import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';

@Component({
  selector: 'app-warning-modal-popup',
  templateUrl: './warning-modal-popup.component.html',
  styleUrls: ['./warning-modal-popup.component.scss']
})
export class WarningModalPopupComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  @Output() callOnPositiveBtnClick: EventEmitter<string> = new EventEmitter();
  @Output() callOnNegativeBtnClick: EventEmitter<string> = new EventEmitter();
  @Input() modalTitle: string;
  @Input() modalMessage: string | SafeHtml | null | undefined;
  @Input() fromPage?: string;
  @Input() delinkAdditionalOption?: string;


  constructor(private rootScopeService: RootScopeService) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  ngOnInit() {

  }

  onNegativeButtonClick(): void {
    this.callOnNegativeBtnClick.emit();
  }

  onPositiveButtonClick(): void {
    this.callOnPositiveBtnClick.emit();
  }

  //calling this function since the popup is closing on click of outer div
  stopEventCapturing(e: Event): void {
    e.stopPropagation();
  }

}
